import React from "react";
import ScholarshipImage1 from "../../../../assets/image/image-scholarship-01.webp";
import ScholarshipImage2 from "../../../../assets/image/image-scholarship-02.webp";
import Image from "../../../elements/Image";
import { Link } from "react-router-dom";

const ScholarshipImage = ({ data }) => {
  const imageData = (data?.image || [])?.slice(0, 2);

  return (
    <>
      <div className="relative grid grid-cols-2 gap-3 xls:gap-8 py-6">
        <div className="w-full aspect-[3/5] overflow-hidden translate-y-3 xls:translate-y-6">
          {imageData[0]?.url && (
            <Image
              src={imageData[0]?.url}
              effect="blur"
              classes="object-cover"
            />
          )}
        </div>
        <div className="w-full aspect-[3/5] overflow-hidden -translate-y-3 xls:-translate-y-6">
          {imageData[1]?.url && (
            <Image
              src={imageData[1]?.url}
              effect="blur"
              classes="object-cover"
            />
          )}
        </div>
        <div className="absolute top-0 left-0 w-full h-full z-[1] flex items-center justify-center">
          <Link
            to={"/"}
            className="inline-block w-24 xls:w-40 aspect-square relative group overflow-hidden rounded-full"
          >
            <svg
              className="w-24 xls:w-40 aspect-square bg-chestnut-rose/75 group-hover:bg-chestnut-rose rounded-full text-white animate-[spin_5s_linear_infinite] transition-all duration-200"
              viewBox="0 0 100 100"
            >
              <defs>
                <path
                  id="circle"
                  d="M50,50 m-37,0a37,37 0 1,1 74,0a37,37 0 1,1 -74,0"
                ></path>
              </defs>
              <text
                className="text-[9px] tracking-widest font-thin"
                fill="white"
              >
                <textPath xlinkHref="#circle" fill="white">
                  {data?.rotateText}
                </textPath>
              </text>
            </svg>
            <div className="absolute top-0 left-0 w-full h-full z-[1] flex items-center justify-center text-2xl xls:text-3xl text-white">
              <i className="fa-light fa-arrow-up-right"></i>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default ScholarshipImage;
